<template>
  <div class="slide slide-empty">
    <div class="empty-content">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="35" stroke="#E0E0E0" stroke-width="2" stroke-dasharray="8 4"/>
        <path d="M40 25V55M25 40H55" stroke="#E0E0E0" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <p class="empty-text">Slide content not available</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptySlide',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    slideId: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/quarterly-slides.scss';

.slide-empty {
  @extend .slide-base;
  background: $paper;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-content {
  text-align: center;
}

.empty-text {
  font-family: $font-body;
  font-size: 18px;
  color: $ink-subtle;
  margin-top: 24px;
}
</style>
